import React from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Link from '@mui/material/Link'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'
import TopBar from './TopBar'

const HELP_ARTICLES = [
  {
    title: 'What is Babel Chat?',
    description: 'Learn about what Babel Chat does, how it can help you learn a new language or interact seamlessly with people who speak another language.',
    href: 'https://babelchat.wordpress.com/2023/03/10/what-is-babel-chat/',
  },
  {
    title: 'How to add a language keyboard',
    description: 'When typing in another language on your phone, it is critical to install the appropriate keyboard.',
    href: 'https://babelchat.wordpress.com/2023/03/10/adding-a-language-keyboard-to-your-phone/',
  },
  {
    title: 'Install for an app-like experience',
    description: 'Get a native app-like experience by installing this progressive web app to your home screen.',
    href: 'https://babelchat.wordpress.com/2023/03/10/install-pwa/',
  },
]

const HelpArticle = ({ title, description, href }) => {
  return (
    <ListItem
      component={Link}
      href={href}
      target='_blank'
      sx={{
        textDecoration: 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
      }}
    >
      <ListItemText sx={{ fontWeight: 700 }}
        primary={title}
        secondary={description}
        primaryTypographyProps={{
          fontWeight: 700,
        }}
      />
    </ListItem>
  )
}

export const Help = () => {
  const navigate = useNavigate()

  return (
    <Box>
      <TopBar
        title='Help Resources'
      />
      <Container>
        <List>
          {HELP_ARTICLES.map((help_article, j) => {
            return (
              <HelpArticle key={j}
                {...help_article}
              />
            )
          })}
        </List>
      </Container>
    </Box>
  )
}
